export default "__VITE_ASSET__DcJrldpm__"